{
  "deselectedItem": "{item} non sélectionné.",
  "select": "Sélectionner",
  "selectedAll": "Tous les éléments sélectionnés.",
  "selectedCount": "{count, plural, =0 {Aucun élément sélectionné} one {# élément sélectionné} other {# éléments sélectionnés}}.",
  "selectedItem": "{item} sélectionné."
}
